import React, { ReactElement } from "react";
import Filter from "./Filter";
import { FilterItemProps } from "./FilterItem";

export interface Tag {
  value: string;
  label: string;
  filterName?: string;
}

export const isFilterItemComponent = (
  component: React.ReactNode,
): component is ReactElement<FilterItemProps, typeof Filter.Item> => {
  return React.isValidElement(component) && component.type === Filter.Item;
};
